<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import { EditableStringField } from '@/components/Fields'
import { StackLayout } from '@/components/Layouts'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import TypographyWithPrefix from '../../../components/Typography/TypographyWithPrefix.vue'

type Props = {
    data: Partial<CheckpointModel>
    isInEditMode?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<CheckpointModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <InformationBaseCard :label="$t('checkpoint.title.informationsTitle')" class="full-width">
        <StackLayout direction="column" :gap="16" class="full-width">
            <EditableStringField
                :label="$t('checkpoint.model.name')"
                :value="data?.name"
                boldLabel
                :isInEditMode="isInEditMode"
                @change="$emit('change', { name: $event })"
                required />
            <TypographyWithPrefix :prefix="$t('checkpoint.model.id')" :label="data?.id" boldLabel />
            <EditableStringField
                :label="$t('checkpoint.model.comments')"
                :value="data?.comments ?? ''"
                @change="$emit('change', { comments: $event })"
                boldLabel
                :isInEditMode="isInEditMode" />
            <slot />
        </StackLayout>
    </InformationBaseCard>
</template>
